// extracted by mini-css-extract-plugin
export default {"main-container":"QuickbooksAppInstallCallback_main-container__Rh4ej"};